import { isValidElement as i } from "react";
function s(t, e) {
  if (!t) return;
  const r = (Array.isArray(t) ? t : [t]).filter(Boolean).filter(i).filter((n) => "type" in n ? n.type?.displayName === e : !1);
  return r.length > 0 ? r : void 0;
}
function f(t, e) {
  const r = s(t, e);
  if (r)
    return Array.isArray(r) ? r[0] : r;
}
function u(t, ...e) {
  if (!t) return null;
  if (Array.isArray(t)) {
    const r = t.filter(Boolean).filter(i).filter((n) => {
      const o = n.type?.displayName;
      return !o || !e.includes(o);
    });
    return r.length > 0 ? r : null;
  }
  if (i(t)) {
    const r = t.type?.displayName;
    return !r || !e.includes(r) ? t : null;
  }
  return t;
}
export {
  u as filterOutComponentsByDisplayName,
  s as findComponentsByDisplayName,
  f as firstComponentsByComponentName
};
